<template>
  <div class="input-field-select" :id="componentId">
    <div class="input-field-select__container" :class="{ 'error': showError }">
      <div class="input-field-select__container__input" :class="{'disabled': disabled}">
        <Select :disabled="disabled" v-model="model" :options="options" :reduce="label => label.value"
          :clearable="false" :searchable="false" :filterable="false" :clearSearchOnSelect="false" label="label"/>
        <label @click="handleOpen" :class="model? 'small':''" :for="name">{{ labelName }}</label>
      </div>
      <slot name="prependIcon"></slot>
    </div>
    <div class="error-message" :class="{ 'active': showError }">{{ errorMessage }}</div>
  </div>
</template>

<script>
import Select from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: "Datetime",
  components: {
    Select
  },
  data() {
    return {
      model: this.initValue ? `${this.initValue}` : null
    };
  },
  props: {
    componentId: {
      type: [String, null],
      default: null
    },
    initValue: {
      type: String
    },
    type: {
      type: String
    },
    name: {
      type: String
    },
    labelName: {
      type: String
    },
    maxlength: {
      type: String
    },
    minlength: {
      type: String
    },
    showError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String
    },
    onBlur: {
      type: Function
    },
    options:{
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange(value) {
      this.$emit("onChange", value);
    },
    handleSubmit ($event) {
      this.$emit("onSubmit", $event);
    },
    handleBlur() {
      this.$emit("onBlur", this.model || '');
    },
    handleOpen(){
      if(this.$refs.datepickerRef){
        this.$refs.datepickerRef.showDayCalendar()
      }
    }
  },
  watch: {
    model (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit("onChange", newVal);
      }
    }
  },
}
</script>

<style lang="scss">
.input-field-select {
  width: 100%;

  &__container {
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 4px;
    border: 1px solid #E5E7E8;
    background-color: #FFFFFF;

    &.error {
      border: 1px solid #ff5252;
    }
  }
}

.input-field-select__container__input {
  position: relative;
  width: 100%;
  height: 56px;
  line-height: 56px;
  // margin-bottom: 15px;

  label {
    position: absolute;
    top: 0;
    left: 0px;
    width: 100%;
    color: #7a8189;
    padding: 0 12px;
    transition: 0.2s all;
    font-size: 14px;
    cursor: text;
  }
  .vs__dropdown-toggle {
    width: 100%;
    border: 0;
    margin-top: 20px;
  }
  // .vs__search{
  //   display: none;
  // }
  .vs--single .vs__selected {
    background-color: transparent;
    border-color: transparent;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 227px;
    margin-left: 5px;
  }
  .vs__selected{
    font-family: Arial, Helvetica, sans-serif;
    display: inline-block;
  }
  .vs__actions{
    padding: 0 16px 0 3px !important;
    .vs__clear{
      display: none;
    }
    
  }

  &.disabled{
    background-color: #f8f8f8;
    .vs__actions{
      .vs__open-indicator{
        display: none;
      }
    }
  }
  // input {
  //   width: 100%;
  //   height: 46px;
  //   outline: 0;
  //   border-radius: 4px;
  //   background-color: #ffffff;
  //   border: none;
  //   font-size: 14px;
  //   padding: 10px 12px 0 12px;
  //   color: #1a1a1a;
  // }

  // input:invalid {
  //   outline: 0;
  // }
  // .input-select:has( input:focus ) ~ label,
  // .input-select:has( input:valid ) ~ label {
  //   font-size: 10px;
  //   top: -12px;
  //   color: #7a8189;
  //   height: 0px;
  // }
  .small{
    font-size: 10px;
    top: -15px;
    color: #7a8189;
    height: 0px;
  }
}
.error-message {
  font-size: 12px;
  color: #ff5252;
  display: none;
}
.error-message.active {
  display: block;
}
.vs__dropdown-menu{
  overflow-y: hidden;
  .vs__dropdown-option{
    white-space: inherit;
  }
}

</style>
<style lang="scss">
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
